import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { NotesContextProvider } from "shared/contextProviders";
import { NotesContent, NotesContentProps } from "./NotesContent";
import { EnumEntityReferenceType } from "gql/generated";

type NotesProps = {
  viewOnly?: boolean;
  _entityId: string;
  type: EnumEntityReferenceType;
  getNoteCreatingState?: ({
    isCreatingNote,
    setIsCreatingNote,
  }: {
    isCreatingNote: boolean;
    setIsCreatingNote: Dispatch<SetStateAction<boolean>>;
  }) => void;
  suggestionsPortalHost?: HTMLElement | null;
} & Omit<NotesContentProps, "isCreatingNote" | "setIsCreatingNote">;

export const Notes = ({
  _entityId,
  type,
  forceSingleColumn = false,
  viewOnly = false,
  viewType = "grid",
  getNoteCreatingState,
  setNoteCount,
  suggestionsPortalHost,
}: NotesProps) => {
  const [isCreatingNote, setIsCreatingNote] = useState(false);

  useEffect(() => {
    getNoteCreatingState?.({
      isCreatingNote,
      setIsCreatingNote,
    });
  }, [isCreatingNote, getNoteCreatingState]);
  return (
    <NotesContextProvider
      defaultEntityId={_entityId}
      defaultEntityType={type}
      viewOnly={viewOnly}
      allowArchiving
      allowDeleting
      waitForDefaultEntity
      includeArchivedNotes
    >
      <NotesContent
        viewType={viewType}
        forceSingleColumn={forceSingleColumn}
        isCreatingNote={isCreatingNote}
        setIsCreatingNote={setIsCreatingNote}
        setNoteCount={setNoteCount}
        suggestionsPortalHost={suggestionsPortalHost}
      />
    </NotesContextProvider>
  );
};
